import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { closePopup } from '../../actions/uiActions';
import { createUser } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class AddUser extends React.Component {
    state = {
        firstName: "",
        lastName: "",
        username: "",
        customerID: "",
        role: "",
        newPW: "",
        confirmNewPW: "",
        teamIDs: []
    }

    changeFName = (event) => {
        this.setState({ firstName: event.target.value })
    }

    changeLName = (event) => {
        this.setState({ lastName: event.target.value })
    }

    changeName = (event) => {
        this.setState({ username: event.target.value })
    }


    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.createUser(this.state.firstName, this.state.lastName, this.state.username, this.state.customerID, this.state.role, this.state.teamIDs, this.state.newPW, this.state.confirmNewPW);
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value })
    }

    handleRole = (event) => {
        event.preventDefault()
        this.setState({ role: event.target.value })
    }

    handleTeamsCheckBoxes = (event) => {
        let ind = this.state.teamIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.teamIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ teamIDs: arr })
    }

    changeText = (event, str) => {
        event.preventDefault()
        this.setState({ [str]: event.target.value })
    }

    populateCustomers = () => {
        if (this.props.role === "IEAdmin") {
            return (
                <>
                <h5 className="mainLable">Customer:</h5>
                <div className="myInputOut">
                    <Select
                        className="myInput"
                        onChange={this.handleCustomerID}
                        value={this.state.customerID}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                    >
                        <MenuItem value="" disabled hidden>
                            Select Customer
                        </MenuItem>
                        {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                    </Select>
                </div>
                </>
            )
        }

        return null
    }

    populateRoles = () => {
        if (this.props.role === "IEAdmin") {
            return (
                <Select
                    className="myInput"
                    defaultValue={this.state.role}
                    onChange={this.handleRole}
                    value={this.state.role}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="" disabled hidden>Select User Role</MenuItem>
                    <MenuItem key={1} value={"IEAdmin"}>IEAdmin</MenuItem>
                    <MenuItem key={4} value={"ClientAdmin"}>Client Admin</MenuItem>
                    <MenuItem key={2} value={"Builder"}>Builder</MenuItem>
                    <MenuItem key={3} value={"Viewer"}>Viewer</MenuItem>
                </Select>
            )
        } else if (this.props.role === "ClientAdmin") {
            return (
                <Select
                    className="myInput"
                    defaultValue={this.state.role}
                    onChange={this.handleRole}
                    value={this.state.role}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="" disabled hidden>Select User Role</MenuItem>
                    <MenuItem key={4} value={"ClientAdmin"}>Client Admin</MenuItem>
                    <MenuItem key={2} value={"Builder"}>Builder</MenuItem>
                    <MenuItem key={3} value={"Viewer"}>Viewer</MenuItem>
                </Select>
            )
        }

        return null
    }

    populateTeams = () => {
        if (this.state.customerID !== null && (this.props.role === "IEAdmin" || this.props.role === "ClientAdmin")) {
            let teams = this.props.teamList.filter(x => x.customer.id === parseInt(this.state.customerID)).sort((a, b) => parseFloat(a.id) - parseFloat(b.id));
            return (<div className="checkOut">
                <label className="checkHead">Teams:</label>
                    <ul>
                        {teams.map(x => (
                            <li key={`team-id-${x.id}`}>
                                <FormControlLabel
                                    control={(
                                        <Checkbox
                                            key={x.id} onChange={this.handleTeamsCheckBoxes}
                                            name="checkedA"
                                            value={x.id} />
                                    )}
                                    label={x.name} />
                            </li>
                        ))}
                    </ul>
            </div>)
        }
        return (<div style={{ align: "center", height: "40px" }} />)
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Add A New User
                </DialogTitle>
                <DialogContent>
                    <form className="form" onSubmit={this.handleSubmit} >
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeFName}
                                value={this.state.firstName}
                                placeholder="First Name"
                                required
                            />
                        </div>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeLName}
                                value={this.state.lastName}
                                placeholder="Last Name"
                            />
                        </div>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeName}
                                value={this.state.username}
                                placeholder="Email" id="username_txt" required
                            />
                        </div>
                        <input
                            type="text"
                            className="myInput"
                            onChange={(event) => this.changeText(event, "newPW")}
                            value={this.state.newPW}
                            placeholder="New Password"
                            id="userpass_txt"
                            required
                        />
                        <input
                            type="text"
                            className="myInput"
                            onChange={(event) => this.changeText(event, "confirmNewPW")}
                            value={this.state.confirmNewPW}
                            placeholder="Confirm New Password"
                            id="confirmuserpass_txt"
                        />
                        <div className="adminSelectbox">
                            {this.populateCustomers()}
                            {this.populateRoles()}
                            {this.populateTeams()}
                        </div>
                        <button className="btn" type="submit" value="Submit" id="submit_btn">
                            Submit
                                </button>
                    </form>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        teamList: state.users.teamList,
        role: state.users.role
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, createUser }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddUser)

